import { query, queryPage, insertRole, updateRole, deleteByid, selectTemplateRole } from "../../api/config/modules/roleManagement";

const state = {
    query: {},
    queryPage: {},
    insertRole: {},
    updateRole: {},
    deleteByid: {},
    selectTemplateRole: {}
};

const mutations = {
    SET_QUERY: (state, query) => {
        state.query = query;
    },
    SET_QUERYPAGE: (state, queryPage) => {
        state.queryPage = queryPage;
    },
    SET_INSERTROLE: (state, insertRole) => {
        state.insertRole = insertRole;
    },
    SET_UPDATEROLE: (state, updateRole) => {
        state.updateRole = updateRole;
    },
    SET_DELETEBYID: (state, deleteByid) => {
        state.deleteByid = deleteByid;
    },
    SET_SELECTTEMPLATEROLE: (state, selectTemplateRole) => {
        state.selectTemplateRole = selectTemplateRole;
    },
};

const actions = {
    GET_QUERY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            query(data)
                .then((res) => {
                    commit("SET_QUERY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_QUERYPAGE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryPage(data)
                .then((res) => {
                    commit("SET_QUERYPAGE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTROLE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertRole(data)
                .then((res) => {
                    commit("SET_INSERTROLE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEROLE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateRole(data)
                .then((res) => {
                    commit("SET_UPDATEROLE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEBYID: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteByid(data)
                .then((res) => {
                    commit("SET_DELETEBYID", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTTEMPLATEROLE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectTemplateRole(data)
                .then((res) => {
                    commit("SET_SELECTTEMPLATEROLE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
